<template>
  <div class="cashcoupon" :style="empty ? {'background': '#fff'} : {}" v-wechat-title="title">
    <Scroller :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :is-finished-data.sync="finished"
              :no-data-text-data.sync="noDataText"
              @on-infinite="onInfinite"
              @on-refresh="onRefresh"
              class="my_scroller"
              ref="my_scroller"

    >
      <div class="list" v-if="list && list.length > 0">
        <ul>
          <li v-for="(item, index) of list" :key="index">
            <div @click="goHome(item)">
              <head-pendant :identity="item.identity">
                <img v-if="item.head" :src="item.head" @error="function(event) {let img = event.srcElement;img.src = errorHeadImg; img.onerror = null;}">
                <img v-if="!item.head" :src="errorHeadImg"/>
              </head-pendant>
              <span class="f13">{{item.name}}</span>
            </div>
            <button class="f10" :class="{'gz': !item.isfollow}" @click="followFn(item)">{{item.isfollow ? '取消关注' : '关注'}}</button>
          </li>
        </ul>
      </div>
    </Scroller>

    <div v-if="empty" class="emptybox" :style="{'height': emptyHeight/100 + 'rem', 'padding': '0.1rem 0.11rem'}">
      <empty v-if="empty" :path="'noFans'" :noDatades="noDatades"></empty>
    </div>
  </div>
</template>

<script>
import empty from '../emptypage/empty'
import Scroller from '../common/Scroller'
import { isWeixin, fenxiang } from '../../assets/common/js/config'
import headPendant from '../common/headPendant'

export default {
  name: 'fansList',
  components: {
    empty,
    Scroller,
    headPendant
  },
  data () {
    return {
      list: [],
      listIndex: null,
      refresh: false,
      loading: false,
      finished: false,
      empty: false,
      nowPage: 0,
      noDataText: '—— 客官，木有啦~ ——',
      emptyHeight: 0,
      noDatades: 1,
      title: ''
    }
  },
  mounted: function () {
    this.emptyHeight = document.body.clientHeight
    this.noDatades = this.$route.query.type == 0 ? 1 : 2
    this.title = this.$route.meta.title = this.$route.query.type == 0 ? '关注' : '粉丝'
    if (isWeixin()) {
      fenxiang({path: 'cashcoupon'})
    }
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  methods: {
    getData: function () {
      var url = this.$ajax.getFollow_URL+'?type=' + this.$route.query.type + '&pageno=' + this.nowPage + '&pagesize=' + this.pagesize + '&authorid=' + (this.$route.query.authorid ? this.$route.query.authorid : '')
      var that = this
      that.$customRequestAjax(url).then(res => {
        if (res.data.code === 200) {
          if (that.nowPage === 1) {
            that.list = res.data.list
            that.refresh = false
          } else {
            that.list = that.list.concat(res.data.list)
          }
          that.loading = false
          if (that.list.length <= 0) {
            that.empty = true
          } else {
            that.empty = false
          }
          if (res.data.list.length < that.pagesize) {
            that.finished = true
          } else {
            that.finished = false
          }
        }
      })
    },
    goHome: function (item) {
      this.$store.commit('COMMUNITY_CENTER_TAB', 0)
      this.$router.push({
        path: '/communitycenter',
        query: {
          authorid: item.authorid
        }
      })
    },
    followFn: function (item) {
      var url = this.$ajax.follow_community_URL, data = {
        authorid: item.authorid,
        isfollow: item.isfollow ? 0 : 1
      }
      this.$customRequestAjax.post(url, data).then(res => {
        if (res.data.code == 200) {
          item.isfollow = item.isfollow == 1 ? 0 : 1
        }
      })
    },
    onRefresh () {
      this.refresh = true
      this.nowPage = 1
      var that = this
      that.getData()
    },
    onInfinite () {
      this.loading = true
      this.finished = false
      var that = this
      that.nowPage++
      that.getData()
    }
  }
}
</script>

<style scoped lang="scss">
  .cashcoupon {
    .list ul {
      background: #ffffff;
      margin-top: 0.1rem;
    }
    .list ul li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.15rem 0;
      margin: 0 0.11rem;
      border-bottom: 0.01rem solid #D8D8D8;
      &:last-of-type {
        border-bottom-width: 0;
      }
      div {
        display: flex;
        align-items: center;
        img {
          width: 0.44rem;
          height: 0.44rem;
          border-radius: 50%;
          object-fit: cover;
        }
        span {
          color: #333333;
          margin-left: 0.1rem;
        }
      }
      button {
        width: 0.64rem;
        height: 0.24rem;
        line-height: 0.24rem;
        text-align: center;
        outline: none;
        border: 0.01rem solid #AFB0AF;
        border-radius: 0.12rem;
        color: #999999;
        background: transparent;
        &.gz {
          border-color: #FC0324;
          color: #FC0324;
        }
      }
    }
  }
</style>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/community/fansList.vue